import React from 'react';
import { LegalPage } from './LegalPages';
import { contactInfo } from '../mock';
import { useLang } from '../context/LanguageContext';

export default function RefundPolicy() {
  const { lang } = useLang();
  return (
    <LegalPage title={lang === 'en' ? 'Refund & Cancellation Policy' : 'रिफंड और रद्दीकरण नीति'} subtitle={lang === 'en' ? 'Fair, transparent and devotion-centric policy' : 'न्यायपूर्ण, पारदर्शी और भक्ति-केन्द्रित नीति'}>
      <p>
        We understand that plans can change. This policy explains the conditions under which
        cancellations and refunds are processed for pujas booked through {contactInfo.domain}.
      </p>

      <h2>1. Cancellation Window</h2>
      <ul>
        <li><b>More than 48 hours before puja start time:</b> Full refund (100%) minus 2% payment gateway charge.</li>
        <li><b>Between 24 – 48 hours before puja start:</b> 50% refund. Prasad Home Delivery add-ons are refunded fully if shipping has not yet started.</li>
        <li><b>Less than 24 hours before puja / on puja day:</b> No refund, as Pandit Ji and samagri preparation is already committed. However, you may reschedule to another puja of equivalent value (subject to availability).</li>
        <li><b>After puja has been performed:</b> No refund. You will receive the puja video, sankalp timing and prasad as promised.</li>
      </ul>

      <h2>2. How to Cancel</h2>
      <p>To cancel a booking, send an email from your registered email ID to
        <a href={`mailto:${contactInfo.email}`}> {contactInfo.email}</a> with subject
        <b> “Cancellation Request – [Booking ID]” </b>, or WhatsApp us at
        <a href={`https://wa.me/${contactInfo.whatsapp}`}> {contactInfo.phone}</a>.
        Provide your booking ID, name, phone and reason. Requests via any other channel
        (Instagram DM, Facebook comments, etc.) will not be considered official.
      </p>

      <h2>3. Refund Processing Time</h2>
      <ul>
        <li>Once approved, refunds are initiated within <b>2 business days</b>.</li>
        <li>Refunds to <b>UPI / Wallets</b> typically reflect in <b>1–3 business days</b>.</li>
        <li>Refunds to <b>Debit / Credit Cards / Netbanking</b> may take <b>5–7 business days</b>
          depending on your bank.</li>
        <li>Refunds are made to the <b>same payment method</b> used for the original transaction.
          We do not issue cash or cheque refunds.</li>
      </ul>

      <h2>4. Failed Transactions</h2>
      <p>
        If your payment was deducted but booking did not confirm, the amount will be auto-refunded
        by Razorpay within 5–7 business days. If not received, contact us with your transaction
        reference number and we will assist you.
      </p>

      <h2>5. Non-Refundable Items</h2>
      <ul>
        <li>Sankalp Dakshina once the puja has been performed.</li>
        <li>Custom samagri that has been dispatched or delivered.</li>
        <li>Personalized Vastra / Rudraksha Mala items that were prepared with your name.</li>
      </ul>

      <h2>6. Wrong Details Provided</h2>
      <p>
        If Sankalp was performed with wrong Name / Gotra due to incorrect details supplied by
        you, we cannot re-do the puja free of cost. You may book a new puja at a discounted
        rate at our discretion.
      </p>

      <h2>7. Reschedule Option</h2>
      <p>
        Instead of a refund, you may request to reschedule your Sankalp to another upcoming
        puja of equivalent value. Reschedule must be requested at least 24 hours before the
        original puja date. Only one reschedule per booking is allowed.
      </p>

      <h2>8. Chargebacks & Disputes</h2>
      <p>
        If you raise a dispute or chargeback with your bank without contacting us first, we
        reserve the right to contest the dispute with proof of service delivery (Sankalp
        video, delivery tracking, etc.). Fraudulent chargebacks may lead to permanent
        blocking of your account.
      </p>

      <h2>9. Contact for Refunds</h2>
      <p>
        For any refund questions, email <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
        or call <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>. We aim to respond within 24 hours.
      </p>
    </LegalPage>
  );
}
